"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const complete_check_svg_1 = __importDefault(require("images/utility-icons/complete_check.svg"));
const merchant_portal_reducer_1 = require("merchant-portal-reducer");
const utils_1 = require("utils");
const forms_1 = require("../forms");
function AuthorizedSignerModal({ isOpen = false, setIsOpen = () => { }, currentLocation, addAuthorizedSigner, withModal = true, subtitle = '', isOnAddSignerPage = false, }) {
    const [stage, setStage] = (0, react_1.useState)('initial');
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const history = (0, react_router_dom_1.useHistory)();
    const handleClose = () => {
        setIsOpen(false);
    };
    const handleReturnToDashboard = () => {
        history.push(config_1.PATH.MERCHANT_PORTAL);
    };
    const handleSubmit = async (values) => {
        setSubmitting(true);
        addAuthorizedSigner(values, currentLocation.locationId)
            .then(() => {
            setStage('success');
        })
            .catch((error) => {
            (0, utils_1.toastError)(error.response.message);
        })
            .finally(() => {
            setSubmitting(false);
        });
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: withModal ? ((0, jsx_runtime_1.jsx)(components_1.Modal, { isOpen: isOpen, setIsOpen: setIsOpen, contentClassName: "with-handle", children: (0, jsx_runtime_1.jsx)("div", { className: "add-signer-inner-container", children: stage === 'initial' ? ((0, jsx_runtime_1.jsx)(forms_1.AddSignerForm, { handleClose: handleClose, handleSubmit: handleSubmit, submitting: submitting, subtitle: subtitle, isOnAddSignerPage: isOnAddSignerPage })) : ((0, jsx_runtime_1.jsxs)("div", { className: "success-container", children: [(0, jsx_runtime_1.jsx)("img", { src: complete_check_svg_1.default, alt: "Submission Successful", className: "icon" }), (0, jsx_runtime_1.jsx)(components_1.H1, { children: "Submission Successful" }), (0, jsx_runtime_1.jsx)(components_1.H3, { variant: "title-large", children: "Thank you providing the updated signer details. We will reach out to create an account for them to sign in and verify practice info and agree to the new terms (you may continue to see this message until your submission is approved)." }), (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", className: "button-warn", onClick: handleClose, "data-testid": "add-signer-done-button", children: "DONE" })] })) }) })) : ((0, jsx_runtime_1.jsx)("div", { className: `add-signer-inner-container ${isOnAddSignerPage ? 'on-add-signer-page' : ''} pad-40`, children: stage === 'initial' ? ((0, jsx_runtime_1.jsx)(forms_1.AddSignerForm, { handleClose: handleClose, handleSubmit: handleSubmit, submitting: submitting, withModal: withModal, subtitle: subtitle, isOnAddSignerPage: isOnAddSignerPage })) : ((0, jsx_runtime_1.jsxs)("div", { className: "success-container", children: [(0, jsx_runtime_1.jsx)("img", { src: complete_check_svg_1.default, alt: "Submission Successful", className: "icon" }), (0, jsx_runtime_1.jsx)(components_1.H1, { children: "Submission Successful" }), isOnAddSignerPage ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.H3, { variant: "title-large", children: "Thank you providing the updated signer details. We will reach out to create an account for them to sign in and verify practice info and agree to the new terms." }), (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", onClick: handleReturnToDashboard, className: "button-primary button-warn-outline", "data-testid": "add-signer-return-to-dashboard-button", children: "RETURN TO DASHBOARD" })] })) : ((0, jsx_runtime_1.jsx)(components_1.H3, { variant: "title-large", children: "Thank you providing the updated signer details. We will reach out to create an account for them to sign in and verify practice info and agree to the new terms (you may continue to see this message until your submission is approved)." }))] })) })) }));
}
function mapStateToProps(state) {
    return {
        currentLocation: merchant_portal_reducer_1.selectors.currentLocation(state),
    };
}
const mapApiAuthToProps = {
    addAuthorizedSigner: apiActions.addAuthorizedSigner,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(AuthorizedSignerModal);
